import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    actionLabel: string;
    cancel: string;
    failedToAddFiles: string;
    view: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Add asset button label */
            actionLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useManageUploadCaptionsDialog.actionLabel?c=2vwzobvqeo4dx", defaultMessage: "Add to Asset" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Cancel button label */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useManageUploadCaptionsDialog.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Warning shown when adding captions failed */
            failedToAddFiles: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useManageUploadCaptionsDialog.failedToAddFiles?c=3snbm39ylut3j", defaultMessage: "Failed to add Captions to Asset." }));
                },
                enumerable: true,
                configurable: true
            },
            /** View button label */
            view: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useManageUploadCaptionsDialog.view?c=3gggk12jubpod", defaultMessage: "View" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
